import React from 'react';
import Loadable from 'react-loadable'

import DefaultLayout from './containers/DefaultLayout';

import TransporterTracker from './views/Transporter/Tracker/Tracker.jsx';

function Loading() {
  return <div>Loading...</div>;
}

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const Nurse = Loadable({
  loader: () => import('./views/Nurse/Nurse'),
  loading: Loading,
});


// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', name: 'Home', component: DefaultLayout, exact: true },
  { path: '/nurse', name: 'Nurse', component: Nurse },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  


  { path: '/transporter/:id', name: 'Transporter Tracker', component: TransporterTracker, exact: true },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js